import { DOMAIN } from 'config';
import type { Server } from 'miragejs';
import { response } from 'mocks/helpers';

export const accessControlEndpoints = (server: Server) => {
  server.get(`${DOMAIN}/access-control`, (schema, request) => {
    return response(request.url, undefined, { body: { method: 'get' } });
  });
  server.post(`${DOMAIN}/access-control`, (schema, request) => {
    const requestData = JSON.parse(request.requestBody);
    return response(request.url, undefined, { body: { method: 'post', requestData } });
  });
  server.put(`${DOMAIN}/access-control`, (schema, request) => {
    const requestData = JSON.parse(request.requestBody);
    return response(request.url, undefined, { body: { method: 'put', requestData } });
  });
  server.delete(`${DOMAIN}/access-control`, (schema, request) => {
    return response(request.url, undefined, { body: { method: 'delete' } });
  });
};
